import * as regionalOne   from './regional-one';
import * as avation       from './avation';
import * as gaTelesis     from './ga-telesis';
import * as leshaBank     from './lesha-bank';
import * as mtAviation    from './mt-aviation';
import * as titan         from './titan';
import * as acumenCapital from './acumen-capital';
import * as jetstream     from './jetstream';

export const LESSORS = {
  'regional-one':   { ...regionalOne.META,   module: regionalOne },
  'avation':        { ...avation.META,        module: avation },
  'ga-telesis':     { ...gaTelesis.META,      module: gaTelesis },
  'lesha-bank':     { ...leshaBank.META,      module: leshaBank },
  'mt-aviation':    { ...mtAviation.META,     module: mtAviation },
  'titan':          { ...titan.META,          module: titan },
  'acumen-capital': { ...acumenCapital.META,  module: acumenCapital },
  'jetstream':      { ...jetstream.META,      module: jetstream },
};

// Cookie lessorAccess.id → lessor key
export const LESSOR_BY_ID = {
  242: 'regional-one',
  321: 'acumen-capital',
  442: 'jetstream',
  504: 'avation',
  498: 'ga-telesis',
  510: 'lesha-bank',
  519: 'mt-aviation',
  480: 'titan',
};

export const LESSOR_LIST = Object.values(LESSORS);
